import type {
  BrandingVersionDto,
  ManagedPreviewSessionDto,
} from "../../api/generated.ts";

export function canCreateUpdatedPreview(
  session: Pick<ManagedPreviewSessionDto, "brandingVersionId" | "status">,
  version: BrandingVersionDto | undefined,
): boolean {
  return Boolean(
    version &&
    version.id === session.brandingVersionId &&
    version.state === "draft" &&
    version.archivedAt === null &&
    session.status !== "ready",
  );
}

export function canRevokePreviewSession(
  session: Pick<ManagedPreviewSessionDto, "status">,
): boolean {
  return session.status === "ready" || session.status === "stale";
}

export function previewSessionTone(
  status: ManagedPreviewSessionDto["status"],
): "success" | "warn" | "neutral" | "danger" {
  if (status === "ready") return "success";
  if (status === "stale") return "warn";
  if (status === "revoked") return "danger";
  return "neutral";
}
